import React, { useEffect } from 'react';

const Shield = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: Shield is not implemented yet.');
  }, []);
  return (
    <>
  { /*Shield */} 
 </>
  );
};

export default Shield;
